const ORGANIZATION_ADMIN_MAIN_NAV_BAR_ITEMS = [
  {
    name: "Users",
    routeName: "users"
  }
];

export default ORGANIZATION_ADMIN_MAIN_NAV_BAR_ITEMS;
